module.exports = __webpack_public_path__ + "static/img/shop_address.10aafb38.jpg";